import { render, staticRenderFns } from "./ValidacionCorreoElectronico.vue?vue&type=template&id=0aa19132"
import script from "./ValidacionCorreoElectronico.vue?vue&type=script&lang=js"
export * from "./ValidacionCorreoElectronico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports